<div class="planner-panel">
  <div class="  mt-2" *ngIf="benefitPlanEnrollmentSet?.activatedDate">
    <h2 class="benefit-headers-font green">Enrollment {{benefitPlanEnrollmentSet.plansYear}} Completed</h2>
  </div>
  <div class="  mt-2" *ngIf="!benefitPlanEnrollmentSet?.activatedDate">
    <h2 class="benefit-headers-font red">Enrollment {{benefitPlanEnrollmentSet.plansYear}} not completed</h2>
  </div>

  <div class="  mt-2">
    <div class="description" *ngIf="isOpenEnrollment && !benefitPlanEnrollmentSet?.activatedDate">
      You can enroll during the open enrollment period.
    </div>
    <div class="description" *ngIf="isOpenEnrollment && benefitPlanEnrollmentSet?.activatedDate">
      You can change your enrollment during the open enrollment period.
    </div>
    <div class="description" *ngIf="isNewHire">
      You can change your completed new hire elections through the hire-date deadline without selecting another life event.
    </div>
    <div class="description" *ngIf="!isOpenEnrollment && !isNewHire && benefitPlanEnrollmentSet?.activatedDate">
      You can change your enrollment only in case of life events such as marriage, divorce, change from Part Time to Full Time, loss of coverage, ...
    </div>

    <div class="description" *ngIf="!benefitPlanEnrollmentSet?.activatedDate && benefitPlanEnrollmentSet?.createdDate">
      If you want to cancel changing your benefits enrollment click below.

      <p class="description" *ngIf="benefitPlanEnrollmentSet?.lifeChangingEventID>1">
        Life changing event: {{getLifeEventLabel(benefitPlanEnrollmentSet)}}
        <br />
        Event date: {{benefitPlanEnrollmentSet?.lifeChangingEventDate | date:'shortDate'}}
      </p>
    </div>
    <div class="alert alert-danger" *ngIf="isEnrollmentExpired">
      <span *ngIf="benefitPlanEnrollmentSet.lifeChangingEventID === 2">{{benefitPlanEnrollmentSet.newHireValidationMessage}} Your unfinished choices have not been converted into a decline.</span>
      <span *ngIf="benefitPlanEnrollmentSet.lifeChangingEventID !== 2">This enrollment has expired. Cancel it before starting another eligible enrollment.</span>
    </div>
  </div>
  <div class=" mt-2" *ngIf="isEnrollmentExpired">

    <button class="benefit-btn " *ngIf="!benefitPlanEnrollmentSet?.activatedDate && benefitPlanEnrollmentSet?.createdDate" (click)="clickCancelEnrollment()">Cancel Enrollment</button>
  </div>
  <div class=" mt-2" *ngIf="!openChangeEnrollment && !isEnrollmentExpired">
    <button class="benefit-btn " [disabled]="savingBenefitEnrollment" *ngIf="benefitPlanEnrollmentSet?.activatedDate || !benefitPlanEnrollmentSet?.createdDate" (click)="clickChangeEnrollment()">{{benefitPlanEnrollmentSet?.createdDate ? 'Change Enrollment' : 'Start Enrollment'}}</button>

    <button class="benefit-btn " *ngIf="!benefitPlanEnrollmentSet?.activatedDate && benefitPlanEnrollmentSet?.createdDate" (click)="clickCancelEnrollment()">Cancel Enrollment</button>
    <button class="benefit-btn green mb-2 btn-lg btn-block  "
             *ngIf="(notSignedDocs>0)"
            [disabled]="savingBenefitEnrollment" routerLink="/benefits-enrollment/docs/list" [queryParams]="{enrollmentSetId: benefitPlanEnrollmentSet?.id}">
      SIGN PLANS FORMS
      <span class="badge badge-danger" *ngIf="notSignedDocs>0">{{notSignedDocs}}</span>
    </button>
    <button class="benefit-btn green ml-3  "
            *ngIf=" benefitPlanEnrollmentSet?.documentToSignID  && !benefitPlanEnrollmentSet?.signedDate"
            [class.disabled]="savingBenefitEnrollment"
            [routerLink]="'/benefits-enrollment/sign/'+benefitPlanEnrollmentSet?.id">
      FINISH AND SIGN
    </button>

  </div>
  <a class="benefit-btn" *ngIf="hasAnyDoc && !notSignedDocs" routerLink="/benefits-enrollment/docs/list"
     [queryParams]="{enrollmentSetId: benefitPlanEnrollmentSet?.id}">View plan forms</a>
  <div class=" mb-2" *ngIf="openChangeEnrollment && !isEnrollmentExpired">
    <div class="description">Select the life changing event in order to proceed with the changes on your enrollment.</div>
    <p-select styleClass="app-select mt-2 w-100" [options]="lifeEventOptions" placeholder="Select life event..." [(ngModel)]="lifeEventSelected"></p-select>
    <div *ngIf="lifeEventSelected == 7">
      <input type="text" placeholder="Describe here the other life changing event" [value]="benefitPlanEnrollmentSet?.lifeChangingEventOther" [(ngModel)]="lifeEventOther" class="mt-2 form-control" />
    </div>
    <div class="mt-2">
      Event date:
      <p-datepicker inputStyleClass="form-control mt-1"
                  [monthNavigator]="true"
                  [yearNavigator]="false"
                  styleClass="w-100"
                  panelStyleClass="calendarPanel"
                  appendTo="body"
                  [hourFormat]="12"
                  [minDate]="lifeEventMinDate"
                  [maxDate]="lifeEventMaxDate"
                  [showTime]="false"
                  placeholder="Select event date..."
                  [(ngModel)]="lifeEventDate"
                  dataType="string"></p-datepicker>
    </div>
    <i *ngIf="savingBenefitEnrollment" class="material-icons rotate text-muted">loop</i>
    <button class="benefit-btn mt-3 " (click)="clickStartChangingEnrollment()">Start changing</button>
    <button class="benefit-btn gray mt-3 ml-3 " (click)="clickCancelChangingEnrollment()">Cancel</button>
  </div>
</div>
<fieldset class="mt-2" *ngIf="benefitPlanEnrollmentSet?.createdDate" [disabled]="isEnrollmentExpired">
  <app-benefits-enrollment-detail [selectedBenefitPlans]="selectedBenefitPlans"
                                  [checkedDependent]="checkedDependent"
                                  [rejectedBenefitPlanTypes]="rejectedBenefitPlanTypes"
                                  [availableBenefitPlans]="availableBenefitPlans"
                                  [previousBenefitPlanSet]="previousBenefitPlanEnrollmentSet"

                                  (benefitPlanEnrollmentSaved)="benefitPlanEnrollmentSaved($event)"
                                  (benefitPlanEnrollmentSaveFailed)="initBenefitPlanEnrollmentSet()"
                                  [(savingBenefitEnrollment)]="savingBenefitEnrollment"

                                  [hasUpdatedProfile]="hasUpdatedProfile"
                                  [activatedDate]="benefitPlanEnrollmentSet?.activatedDate"
                                  [benefitPlanEnrollmentSetID]="benefitPlanEnrollmentSet?.id"
                                  [plansYear]="benefitPlanEnrollmentSet?.plansYear"
                                  [lifeChangingEventDate]="benefitPlanEnrollmentSet?.lifeChangingEventDate"
                                  [lifeChangingEventID]="benefitPlanEnrollmentSet?.lifeChangingEventID"></app-benefits-enrollment-detail>

</fieldset>
<div class=" mt-3" *ngIf="notSignedDocs > 0 && !isEnrollmentExpired">
  <i *ngIf="savingBenefitEnrollment" class="material-icons rotate text-muted">loop</i>
  <button class="benefit-btn green mb-2 btn-lg btn-block  " [disabled]="savingBenefitEnrollment" routerLink="/benefits-enrollment/docs/list" [queryParams]="{enrollmentSetId: benefitPlanEnrollmentSet?.id}">
    SIGN PLANS FORMS
    <span class="badge badge-danger" *ngIf="notSignedDocs>0">{{notSignedDocs}}</span>
  </button>
</div>
<div class=" mt-3" *ngIf=" benefitPlanEnrollmentSet?.documentToSignID  && !benefitPlanEnrollmentSet?.signedDate && !isEnrollmentExpired">
  <i *ngIf="savingBenefitEnrollment" class="material-icons rotate text-muted">loop</i>
  <button class="benefit-btn green mb-2 btn-lg btn-block " [class.disabled]="savingBenefitEnrollment" [routerLink]="'/benefits-enrollment/sign/'+benefitPlanEnrollmentSet?.id">
    FINISH AND SIGN
  </button>
</div>

